export default "__VITE_ASSET__RBsRWC0k__"